import Store from 'redux/store';
import { FETCH_POINTS_PLUS_CASH, FETCH_POINTS_PLUS_CASH_SUCCESS, FETCH_POINTS_PLUS_CASH_FAIL } from 'redux/Reducers/PointsPlusCash/PointsPlusCashReducer';
import { cloudloyalty } from '../clients';

// eslint-disable-next-line default-param-last
const FetchPointsPlusCash = async (User, finallyCallback = () => {}, { sku, vendorId, originalId }) => {
  Store.dispatch({ type: FETCH_POINTS_PLUS_CASH, payload: { sku } });
  cloudloyalty(User).get(`/v2/products/skus/${sku}/suggestedPointsPlusCash?vendorId=${vendorId}&originalId=${originalId}`).then((response) => {
    Store.dispatch({
      type: FETCH_POINTS_PLUS_CASH_SUCCESS,
      payload: {
        sku,
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_POINTS_PLUS_CASH_FAIL, payload: { sku }, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export default FetchPointsPlusCash;
